export const IDE_HEADER_HEIGHT = 40;
export const LOGO_WIDTH = 50;
